import { StateCreator, create } from 'zustand'
import { devtools } from 'zustand/middleware'

export interface PricingStore {
  chosenTab: number
  setChosenTab: (value: number) => void
}

const pricingStore = (set: (fn: (state: PricingStore) => PricingStore) => void) => ({
  chosenTab: 0,
  setChosenTab: (value: number) => {
    set((state: PricingStore) => ({
      ...state,
      chosenTab: value,
    }))
  },
})

const usePricingStore = create<PricingStore>()(
  devtools(
    pricingStore as StateCreator<PricingStore, [['zustand/devtools', never]], [], PricingStore>
  )
)
export default usePricingStore
